import React, {
    useContext, useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/components';
import { SG_AA_PREMIUM_PAGE_ACTION } from 'sg-adobe-analytics/AdobeAnalyticsConstants';
import messages from './SgDeclarationsDocuments.messages';

function SgDeclarationsDocuments(props) {
    const {
        isBullets,
        acceptText,
        importantInfoLink,
        lobDocuments
    } = props;

    const translator = useContext(TranslatorContext);

    const adobeBaseValue = `${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_1.DECLARATIONS}|${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_2.TEXT}|`;

    const goToIpid = (event) => {
        if (event) {
            event.preventDefault();
        }
        const ipidUrl = window.location.href.split('/')[0];
        const newUrl = '#/IPID';
        window.open(ipidUrl + newUrl);
    };

    const importantInfo = useMemo(() => {
        return (
            <Link
                id="importantInfoLink"
                href={importantInfoLink}
                target="_blank"
                adobeValue={`${adobeBaseValue}${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.IMPORTANT_STATEMENTS}`}
            >
                {translator(messages.ImportantInfoLink)}
            </Link>
        );
    }, []);

    const ipidLink = useMemo(() => {
        return (
            <Link
                id="ipidLink"
                href="/"
                onClick={goToIpid}
                adobeValue={`${adobeBaseValue}${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.IPID}`}
            >
                {translator(messages.IpidLink)}
            </Link>
        );
    }, [adobeBaseValue, translator]);

    return (
        <>
            {translator(messages.AcceptInfo, { acceptText: acceptText })}
            { isBullets && <span>{translator(messages.Following)}</span>}
            {isBullets
                ? (
                    <ul>
                        <li>
                            {importantInfo}
                        </li>
                        {lobDocuments}
                        <li>
                            {ipidLink}
                        </li>
                    </ul>
                )
                : (
                    <>
                        {importantInfo}
                        { lobDocuments
                            && (
                                <>
                                    <span>, </span>
                                    {lobDocuments}
                                </>
                            )

                        }
                        <span> and </span>
                        {ipidLink}
                    </>

                )
            }
        </>
    );
}

SgDeclarationsDocuments.defaultProps = {
    isBullets: false,
    acceptText: 'Accept'
};

export default SgDeclarationsDocuments;
